// extracted by mini-css-extract-plugin
export default {"fields":"file-notes_fields__fuilh","notes":"file-notes_notes__p2x9L"};